function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #5b5b5b;\r\n      }\r\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "noun_Share_3109247",
  transform: "translate(-1.907 -30.818)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_98",
  "data-name": "Group 98",
  transform: "translate(1.907 30.818)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_88",
  "data-name": "Group 88",
  transform: "translate(0 5.612)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_87",
  "data-name": "Group 87"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  className: "cls-1",
  d: "M56.457,186.151a2.069,2.069,0,1,1-1.666-2.03,2.089,2.089,0,0,1,1.666,2.03.184.184,0,0,0,.367,0,2.435,2.435,0,1,0-1.956,2.389,2.462,2.462,0,0,0,1.956-2.389A.184.184,0,0,0,56.457,186.151Z",
  transform: "translate(-51.959 -183.718)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_93",
  "data-name": "Group 93",
  transform: "translate(9.672 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_90",
  "data-name": "Group 90"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_89",
  "data-name": "Group 89"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_61",
  "data-name": "Path 61",
  className: "cls-1",
  d: "M319.957,33.251a2.066,2.066,0,1,1-1.663-2.03,2.089,2.089,0,0,1,1.663,2.03.184.184,0,0,0,.367,0,2.435,2.435,0,1,0-1.956,2.389,2.462,2.462,0,0,0,1.956-2.389A.184.184,0,0,0,319.957,33.251Z",
  transform: "translate(-315.459 -30.818)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_92",
  "data-name": "Group 92",
  transform: "translate(0 11.228)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_91",
  "data-name": "Group 91"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_62",
  "data-name": "Path 62",
  className: "cls-1",
  d: "M319.957,339.151a2.066,2.066,0,1,1-1.663-2.03,2.089,2.089,0,0,1,1.663,2.03.184.184,0,0,0,.367,0,2.435,2.435,0,1,0-1.956,2.389,2.462,2.462,0,0,0,1.956-2.389A.184.184,0,0,0,319.957,339.151Z",
  transform: "translate(-315.459 -336.718)"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_95",
  "data-name": "Group 95",
  transform: "translate(4.076 3.255)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_94",
  "data-name": "Group 94",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  className: "cls-1",
  d: "M163.281,123.136q.986-.556,1.975-1.116,1.564-.886,3.131-1.769c.242-.136.484-.275.727-.411a.183.183,0,0,0-.184-.316q-.986.556-1.975,1.116-1.564.886-3.131,1.769c-.242.136-.484.275-.727.411-.209.114-.022.433.184.316Z",
  transform: "translate(-163.006 -119.498)"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_97",
  "data-name": "Group 97",
  transform: "translate(4.075 9.175)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_96",
  "data-name": "Group 96",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  className: "cls-1",
  d: "M163.059,281.14c.657.371,1.314.745,1.975,1.116q1.564.886,3.131,1.769c.242.136.484.275.727.411.206.117.393-.2.184-.316-.657-.371-1.314-.745-1.975-1.116q-1.564-.886-3.131-1.769c-.242-.136-.484-.275-.727-.411a.183.183,0,0,0-.184.316Z",
  transform: "translate(-162.97 -280.798)"
})))));

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.537,
    height: 16.095,
    viewBox: "0 0 14.537 16.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.33bada18.svg";
export { ForwardRef as ReactComponent };